
























	import Vue from 'vue';

    export default Vue.extend({
        name: "RaidDashboardPage",
        data () {
            return {
                items: [
                    { id: 1, title: 'Spielerliste', route: '/raid/spielerliste', icon: 'people' },
                    { id: 2, title: 'Termine', route: '/raid/termine', icon: 'calendar_today'},
                    { id: 3, title: 'Archiv', route: '/raid/archiv', icon: 'book' },
                    { id: 4, title: 'Blankos', route: '/raid/blankos', icon: 'border_clear' },
					{ id: 5, title: 'Einstellungen', route: '/raid/settings', icon: 'settings' },
                    //{ id: 5, title: 'Statistiken', route: '/raid/statistiken', icon: 'show_chart' },
                ]
            }
        }
    })
